<div class="flip-book-editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <!-- Mở danh sách hình ảnh -->
    <button class="upload-background-image mt-2" (click)="openModalEditImages()">
      {{'mo_danh_sach_hinh_anh_hoac_them_hinh_anh' | translate}}
    </button>
    <!-- Thời gian lật -->
    <div class="config-name mt-2">
      <span class="title w-50">{{'thoi_gian_lat' | translate}}</span>
      <nz-input-number
      [(ngModel)]="config.flip.transition"
      [nzMin]="0.1" [nzMax]="10" [nzStep]="0.1"
      (nzBlur)="
        class['flip-book__page']['transition'] = 'transform ' + $event + 's ease';
        updateClassAndConfig()
      ">
      </nz-input-number>
    </div>
    <!-- Tự động lật -->
    <div class="config-name mt-2">
      <span class="title w-50">{{'tu_dong_lat' | translate}}</span>
      <nz-switch [(ngModel)]="config.flip.is_auto_flip" (ngModelChange)="updateConfig()">
      </nz-switch>
    </div>
    <!-- Cấu hình tự động lật -->
    <li nz-submenu nzTitle="{{'cau_hinh_tu_dong'| translate}}" [(nzOpen)]="openMapSub.menu1" (nzOpenChange)="openHandler('menu1', true)"
    *ngIf="config.flip?.is_auto_flip">
      <!-- Tự động lật -->
      <div class="config-name">
        <span class="title w-50">{{'thoi_gian_chuyen_trang' | translate}} (ms)</span>
        <nz-input-number
        [(ngModel)]="config.flip.flip_interval"
        [nzMin]="500" [nzMax]="10000" [nzStep]="500"
        (nzBlur)="updateConfig()">
        </nz-input-number>
      </div>
    </li>
    <!-- Cấu hình object-fit -->
    <app-object-fit-config  [device]="device" [class]="class" [objectFitClass]="class['flip-book__page-img']"
      [style_field]="style_fields[0]" (isViewAll)="openViewAll($event)" [objectChoosing]="objectChoosing">
    </app-object-fit-config>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <div class="editor-content" *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" class="mt-2">
      <!-- Hiển thị -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <app-hide-show-config  [elementChoosing]="objectChoosing" [device]="device" >
        </app-hide-show-config>
      </li>
      
      <!-- Cấu hình cụm nút -->
      <li nz-submenu nzTitle="{{'cum_nut'| translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <ng-container>
          <!-- Vị trí từ dưới lên -->
          <div class="config-name">
            <span class="title w-50">{{'vi_tri_tu_duoi_len' | translate}}</span>
            <nz-input-number
            [ngModel]="class['flip-book__controls']['bottom'] | vhnumber"
            [nzMin]="0" [nzMax]="100" [nzStep]="1"
            (ngModelChange)="class['flip-book__controls']['bottom'] = $event + '%'"
            (nzBlur)="handleSetPositionControls($event)">
            </nz-input-number>
          </div>
          <!-- Căn ngang -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'can_ngang' | translate}}</span>
            <nz-select [(ngModel)]="class['flip-book__controls']['justify-content']" (ngModelChange)="updateClass()">
              <nz-option nzValue="flex-start" [nzLabel]="'trai' | translate"></nz-option>
              <nz-option nzValue="center" [nzLabel]="'giua' | translate"></nz-option>
              <nz-option nzValue="flex-end" [nzLabel]="'phai' | translate"></nz-option>
              <nz-option nzValue="space-between" [nzLabel]="'2_ben' | translate"></nz-option>
            </nz-select>
          </div>
          <ng-container *ngIf="class['flip-book__controls']['justify-content'] !== 'center'">
            <!-- Cấu hình khoảng cách bên trái -->
            <div *ngIf="['space-between', 'flex-start'].includes(class['flip-book__controls']['justify-content'])" class="config-name mt-2">
              <span class="title w-50">{{'khoang_cach_ben_trai' | translate}}</span>
              <nz-input-number
                [ngModel]="class['flip-book__btn-prev']['margin-left'] | vhnumber"
                [nzMin]="0" [nzMax]="50" [nzStep]="1"
                (ngModelChange)="class['flip-book__btn-prev']['margin-left'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <!-- Cấu hình khoảng cách bên phải -->
            <div *ngIf="['space-between', 'flex-end'].includes(class['flip-book__controls']['justify-content'])" class="config-name mt-2">
              <span class="title w-50">{{'khoang_cach_ben_phai' | translate}}</span>
              <nz-input-number
                [ngModel]="class['flip-book__btn-next']['margin-right'] | vhnumber"
                [nzMin]="0" [nzMax]="50" [nzStep]="1"
                (ngModelChange)="class['flip-book__btn-next']['margin-right'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
          </ng-container>
          <ng-container *ngIf="class['flip-book__controls']['justify-content'] !== 'space-between'">
            <!-- Cấu hình khoảng cách giữa 2 nút -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'khoang_cach_giua_2_nut' | translate}}</span>
              <nz-input-number
                [ngModel]="class['flip-book__controls']['gap'] | vhnumber"
                [nzMin]="0" [nzMax]="50" [nzStep]="1"
                (ngModelChange)="class['flip-book__controls']['gap'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
          </ng-container>
          <!-- Độ mờ nút khi ở trang đầu hoặc ở trang cuối -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'do_mo_nut_khi_o_trang_dau_hoac_o_trang_cuoi' | translate}}</span>
            <nz-input-number
              [ngModel]="class['flip-book__controls']['bottom'] | vhnumber"
              [nzMin]="0" [nzMax]="100" [nzStep]="1"
              (ngModelChange)="class['flip-book__controls']['bottom'] = $event + '%'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
        </ng-container>
      </li>

      <!-- Cấu hình nút bên trái (prev) -->
      <li nz-submenu nzTitle="{{'nut_trai'| translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <ng-container>
          <!-- Cấu hình màu nền nút -->
          <div class="config-name">
            <span class="title w-50">{{'mau_nen' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
              [(colorPicker)]="class['flip-book__btn-prev']['background-color']"
              [style.background]="class['flip-book__btn-prev']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <!-- Cấu hình hình dạng viền -->
          <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMapSub.menu1" (nzOpenChange)="openHandler('menu1', true)">
            <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class"
              [borderClass]="class['flip-book__btn-prev']" [id_object]="objectChoosing._id">
            </app-borders-config>
          </li>
          <!-- Cấu hình bo tròn -->
          <li nz-submenu nzTitle="{{'bo_tron'| translate}}" [(nzOpen)]="openMapSub.menu2" (nzOpenChange)="openHandler('menu2', true)">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['flip-book__btn-prev']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>
          <!-- Cấu hình khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem'| translate}}" [(nzOpen)]="openMapSub.menu3" (nzOpenChange)="openHandler('menu3', true)">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['flip-book__btn-prev']" [paddingConfigs]="[
              { type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }
            ]">
            </app-padding-config>
          </li>
          <!-- Cấu hình biểu tượng -->
          <li nz-submenu nzTitle="{{'bieu_tuong'| translate}}" [(nzOpen)]="openMapSub.menu4" (nzOpenChange)="openHandler('menu4', true)">
            <!-- Chọn biểu tượng -->
            <div>
              <span>{{ 'chon_bieu_tuong' | translate }}</span>
              <div class="config-name">
                <div class="w-50"><mat-icon>{{ config.icon.prev }}</mat-icon></div>
                <button nz-button nzType="default" (click)="openDialogChooseIcon('prev')" style="border-radius: 5px">
                  {{'thay_doi' | translate}}
                </button>
              </div>
            </div>
            <!-- Cấu hình màu biểu tượng -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
                [(colorPicker)]="class['flip-book__icon-prev']['color']"
                [style.background]="class['flip-book__icon-prev']['color']"
                (colorPickerClose)="updateClass()" />
            </div>
            <!-- Cấu hình kích thước biểu tượng -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'kich_thuoc' | translate}}</span>
              <nz-input-number
                [ngModel]="class['flip-book__icon-prev']['font-size'] | vhnumber"
                [nzMin]="10" [nzMax]="50" [nzStep]="1"
                (ngModelChange)="class['flip-book__icon-prev']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
          </li>
        </ng-container>
      </li>

      <!-- Cấu hình nút bên phải (next) -->
      <li nz-submenu nzTitle="{{'nut_phai'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <ng-container>
          <!-- Cấu hình màu nền nút -->
          <div class="config-name">
            <span class="title w-50">{{'mau_nen' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
              [(colorPicker)]="class['flip-book__btn-next']['background-color']"
              [style.background]="class['flip-book__btn-next']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <!-- Cấu hình hình dạng viền -->
          <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMapSub.menu1" (nzOpenChange)="openHandler('menu1', true)">
            <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class"
              [borderClass]="class['flip-book__btn-next']" [id_object]="objectChoosing._id">
            </app-borders-config>
          </li>
          <!-- Cấu hình bo tròn -->
          <li nz-submenu nzTitle="{{'bo_tron'| translate}}" [(nzOpen)]="openMapSub.menu2" (nzOpenChange)="openHandler('menu2', true)">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['flip-book__btn-next']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>
          <!-- Cấu hình khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem'| translate}}" [(nzOpen)]="openMapSub.menu3" (nzOpenChange)="openHandler('menu3', true)">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['flip-book__btn-next']" [paddingConfigs]="[
              { type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }
            ]">
            </app-padding-config>
          </li>
          <!-- Cấu hình biểu tượng -->
          <li nz-submenu nzTitle="{{'bieu_tuong'| translate}}" [(nzOpen)]="openMapSub.menu4" (nzOpenChange)="openHandler('menu4', true)">
            <!-- Chọn biểu tượng -->
            <div>
              <span>{{ 'chon_bieu_tuong' | translate }}</span>
              <div class="config-name">
                <div class="w-50"><mat-icon>{{ config.icon.next }}</mat-icon></div>
                <button nz-button nzType="default" (click)="openDialogChooseIcon('next')" style="border-radius: 5px">
                  {{'thay_doi' | translate}}
                </button>
              </div>
            </div>
            <!-- Cấu hình màu biểu tượng -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
                [(colorPicker)]="class['flip-book__icon-next']['color']"
                [style.background]="class['flip-book__icon-next']['color']"
                (colorPickerClose)="updateClass()" />
            </div>
            <!-- Cấu hình kích thước biểu tượng -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'kich_thuoc' | translate}}</span>
              <nz-input-number
                [ngModel]="class['flip-book__icon-next']['font-size'] | vhnumber"
                [nzMin]="10" [nzMax]="50" [nzStep]="1"
                (ngModelChange)="class['flip-book__icon-next']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
          </li>
        </ng-container>
      </li>

      <!-- Cấu hình nút play/pause -->
      <li nz-submenu nzTitle="{{'nut_chay_hoac_tam_dung'| translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')"
      *ngIf="config.flip?.is_auto_flip">
        <ng-container>
          <!-- Cấu hình màu nền nút -->
          <div class="config-name">
            <span class="title w-50">{{'mau_nen' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
              [(colorPicker)]="class['flip-book__btn-play']['background-color']"
              [style.background]="class['flip-book__btn-play']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <!-- Cấu hình hình dạng viền -->
          <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMapSub.menu1" (nzOpenChange)="openHandler('menu1', true)">
            <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class"
              [borderClass]="class['flip-book__btn-play']" [id_object]="objectChoosing._id">
            </app-borders-config>
          </li>
          <!-- Cấu hình bo tròn -->
          <li nz-submenu nzTitle="{{'bo_tron'| translate}}" [(nzOpen)]="openMapSub.menu2" (nzOpenChange)="openHandler('menu2', true)">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['flip-book__btn-play']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>
          <!-- Cấu hình khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem'| translate}}" [(nzOpen)]="openMapSub.menu3" (nzOpenChange)="openHandler('menu3', true)">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['flip-book__btn-play']" [paddingConfigs]="[
              { type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }
            ]">
            </app-padding-config>
          </li>
          <!-- Cấu hình biểu tượng -->
          <li nz-submenu nzTitle="{{'bieu_tuong'| translate}}" [(nzOpen)]="openMapSub.menu4" (nzOpenChange)="openHandler('menu4', true)">
            <!-- Chọn biểu tượng tiếp tục -->
            <div>
              <span>{{ 'chon_bieu_tuong_tiep_tuc' | translate }}</span>
              <div class="config-name">
                <div class="w-50"><mat-icon>{{ config.icon.play }}</mat-icon></div>
                <button nz-button nzType="default" (click)="openDialogChooseIcon('play')" style="border-radius: 5px">
                  {{'thay_doi' | translate}}
                </button>
              </div>
            </div>
            <!-- Chọn biểu tượng tạm dừng -->
            <div class="mt-2">
              <span>{{ 'chon_bieu_tuong_tam_dung' | translate }}</span>
              <div class="config-name">
                <div class="w-50"><mat-icon>{{ config.icon.pause }}</mat-icon></div>
                <button nz-button nzType="default" (click)="openDialogChooseIcon('pause')" style="border-radius: 5px">
                  {{'thay_doi' | translate}}
                </button>
              </div>
            </div>
            <!-- Cấu hình màu biểu tượng -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [cpWidth]="'230px'"
                [(colorPicker)]="class['flip-book__icon-play']['color']"
                [style.background]="class['flip-book__icon-play']['color']"
                (colorPickerClose)="updateClass()" />
            </div>
            <!-- Cấu hình kích thước biểu tượng -->
            <div class="config-name mt-2">
              <span class="title w-50">{{'kich_thuoc' | translate}}</span>
              <nz-input-number
                [ngModel]="class['flip-book__icon-play']['font-size'] | vhnumber"
                [nzMin]="10" [nzMax]="50" [nzStep]="1"
                (ngModelChange)="class['flip-book__icon-play']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
          </li>
        </ng-container>
      </li>

      <!-- Cấu hình lật -->
      <li nz-submenu nzTitle="{{'cau_hinh_lat'| translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <ng-container>
          <!-- Thời gian lật -->
          <div class="config-name">
            <span class="title w-50">{{'thoi_gian_lat' | translate}}</span>
            <nz-input-number
            [(ngModel)]="config.flip.transition"
            [nzMin]="0.1" [nzMax]="10" [nzStep]="0.1"
            (nzBlur)="
              class['flip-book__page']['transition'] = 'transform ' + $event + 's ease';
              updateClassAndConfig()
            ">
            </nz-input-number>
          </div>
          <!-- Tự động lật -->
          <div class="config-name mt-2">
            <span class="title w-50">{{'tu_dong_lat' | translate}}</span>
            <nz-switch [(ngModel)]="config.flip.is_auto_flip" (ngModelChange)="updateConfig()">
            </nz-switch>
          </div>
          <!-- Cấu hình tự động lật -->
          <li nz-submenu nzTitle="{{'cau_hinh_tu_dong'| translate}}" [(nzOpen)]="openMapSub.menu1" (nzOpenChange)="openHandler('menu1', true)"
          *ngIf="config.flip?.is_auto_flip">
            <!-- Tự động lật -->
            <div class="config-name">
              <span class="title w-50">{{'thoi_gian_chuyen_trang' | translate}} (ms)</span>
              <nz-input-number
              [(ngModel)]="config.flip.flip_interval"
              [nzMin]="500" [nzMax]="10000" [nzStep]="500"
              (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
          </li>
          <!-- Cấu hình object-fit -->
          <li nz-submenu nzTitle="{{'do_bao_phu'| translate}}" [(nzOpen)]="openMapSub.menu2" (nzOpenChange)="openHandler('menu2', true)">
            <app-object-fit-config  [device]="device" [class]="class" [objectFitClass]="class['flip-book__page-img']"
              [style_field]="style_fields[0]" (isViewAll)="openViewAll($event)" [objectChoosing]="objectChoosing">
            </app-object-fit-config>
          </li>
        </ng-container>
      </li>

      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class" [borderClass]="class['flip-book']"
          [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3 cursor-pointer" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(style_fields[1])">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- Tạo bóng -->
      <li nz-submenu nzTitle="{{'do_bong'| translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['flip-book']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
    </ul>
  </div>

  <!-- Mở rộng -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Mở rộng cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 1">
      <div class="field-row">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'vi_tri_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'ngang'| translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_x" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'doc'| translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_y" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>
      </div>
      <div class="field-row mt-2">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'phong_thu_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'do_co_gian'| translate}}</p>
        </div>
        <nz-slider [(ngModel)]="config.image.transfrom_scale" (nzOnAfterChange)="scale()"
          [nzMin]="0.1" [nzMax]="2" [nzStep]="0.1"></nz-slider>
      </div>
    </div>
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['flip-book']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>
